<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="data"
    [loading]="loading"
    id="host-group-detail-host-data-table">
    <ng-template [meta]="{'field': 'usage'}"
        let-col
        let-data="rowData"
        nTemplate>
        <div style="width: 150px">
            <n-percent-bar *ngIf="!SWITCH.IS_DIRECT_MODE"
                [nTooltip]="capTips"
                [value]="usageValue | fn :data"
                style="flex: 1;">
            </n-percent-bar>
            <p [class]="SWITCH.IS_DIRECT_MODE ? 'direct-mode-capacity' : 'sub'" style="text-align: right;">
                {{(+data.capacity || 0) | adaptUnit :'Sector'}}
            </p>
        </div>
        <ng-template #capTips>
            <n-kv *ngIf="data">
                <n-kv-item [key]="i18n.get('common.capacity_total_column')">
                    {{(+data.capacity || 0) | adaptUnit :'Sector'}}
                </n-kv-item>
                <n-kv-item [key]="i18n.get('common.allocatedCapacity_short_lab')">
                    {{(+data.allocatedCapacity || 0) | adaptUnit :'Sector'}}
                </n-kv-item>
                <n-kv-item [key]="i18n.get('storage.storagePool_term_dataProtection_column')" *ngIf="!FeatureConfig.IsHideProtection">
                    {{(+data.protectionCapacity || 0) | adaptUnit :'Sector'}}
                </n-kv-item>
            </n-kv>
        </ng-template>
    </ng-template>
</n-data-table>
